function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.033 4.83032C14.3494 4.83032 14.6109 5.06545 14.6523 5.37051L14.658 5.45532V16.8035C14.658 17.1486 14.3781 17.4285 14.033 17.4285C13.7165 17.4285 13.455 17.1933 13.4137 16.8883L13.408 16.8035V5.45532C13.408 5.11014 13.6878 4.83032 14.033 4.83032Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.988 12.9492C17.2316 12.7046 17.6273 12.7037 17.8719 12.9472C18.0943 13.1686 18.1153 13.5157 17.9343 13.7608L17.874 13.8311L14.4758 17.2449C14.2537 17.4681 13.9052 17.4884 13.6601 17.3058L13.5899 17.2449L10.1917 13.8311C9.94823 13.5864 9.94914 13.1907 10.1938 12.9472C10.4162 12.7258 10.7635 12.7064 11.0077 12.8885L11.0777 12.9492L14.0325 15.9175L16.988 12.9492Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.75928 2.56909C6.07569 2.56909 6.33719 2.80422 6.37857 3.10928L6.38428 3.19409V14.5422C6.38428 14.8874 6.10446 15.1672 5.75928 15.1672C5.44286 15.1672 5.18137 14.9321 5.13998 14.627L5.13428 14.5422V3.19409C5.13428 2.84891 5.4141 2.56909 5.75928 2.56909Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.31639 2.75268C5.53849 2.52956 5.88703 2.50927 6.13212 2.69183L6.20232 2.75268L9.60046 6.16657C9.84398 6.41121 9.84306 6.80694 9.59842 7.05045C9.37602 7.27183 9.02876 7.2912 8.7845 7.10909L8.71454 7.04841L5.75917 4.07916L2.80417 7.04841C2.58279 7.27081 2.23562 7.29179 1.99053 7.11081L1.92029 7.05045C1.69789 6.82908 1.67691 6.48191 1.85789 6.23681L1.91824 6.16657L5.31639 2.75268Z",
  fill: "black"
});

var SvgIntegrate = function SvgIntegrate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntegrate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/integrate.1f14d9e5.svg";
export { ForwardRef as ReactComponent };